<div class="campaign-card-overlay">
  <div class="campaign-card-overlay__frame">
    <img [src]="imageUrl || fallbackImage" [alt]="name ?? ''" class="campaign-card-overlay__image" (error)="onImageError($event)" />
  </div>
</div>
